import api from '@/utils/api'

export default {
    getStatsByLeague(leagueId, phase, season) {
        return api.get(`teams/stats/league/${leagueId}?phase=${phase}&seasonId=${season}`)
    }
}
